(function () {
  function fireMiniCartPageview() {
    window._uxa = window._uxa || [];
    const qs = location.search;
    window._uxa.push(['setQuery', qs + (qs ? '&' : '?') + 'minicart-open']);
    window._uxa.push([
      'trackPageview',
      window.location.pathname + window.location.hash.replace('#', '?__'),
    ]);
    window._uxa.push(['setQuery', qs]);
  }

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  let wasOpen = drawer.classList.contains('active');
  if (wasOpen) fireMiniCartPageview();

  const mo = new MutationObserver(() => {
    const isOpen = drawer.classList.contains('active');
    if (isOpen && !wasOpen) fireMiniCartPageview();
    wasOpen = isOpen;
  });
  mo.observe(drawer, { attributeFilter: ['class'] });

  window.addEventListener('unload', () => mo.disconnect());
})();
